'use client';
import { useTranslate } from '@jd/i18n';
import { IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useIsMobile from '../../../../utils/useIsMobile';
import { useCallback } from 'react';

type Props = {
  isFirst: boolean;
  isLast: boolean;
  value: number;
  onChange: (value: number) => void;
};

const Selector = ({ isFirst, isLast, value, onChange }: Props) => {
  const t = useTranslate('common');
  const isMobile = useIsMobile();

  return (
    <Stack
      direction={'row'}
      spacing={{ md: 8, xs: 2 }}
      sx={{
        width: '100%',
        justifyContent: isMobile ? 'space-between' : 'start',
        alignItems: 'center',
      }}
    >
      <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
        <IconButton
          aria-label="previous image"
          disabled={isFirst}
          sx={{
            borderRadius: 1,
            border: '1px solid grey',
            borderColor: 'grey.500',
          }}
          onClick={() => {
            onChange(value - 1);
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography color={isFirst ? 'textSecondary' : 'textPrimary'}>
          {t('previous')}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
        <Typography color={isLast ? 'textSecondary' : 'textPrimary'}>
          {t('next')}
        </Typography>
        <IconButton
          aria-label="next image"
          disabled={isLast}
          sx={{
            borderRadius: 1,
            border: '1px solid grey',
            borderColor: 'grey.500',
          }}
          onClick={() => {
            onChange(value + 1);
          }}
        >
          <ArrowForwardIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
};
export default Selector;
